import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { uuidv4 } from 'common/commonFunc';
import { QuestionType } from 'common/enum';
import CkEditorWord4 from 'component/common/CkEditorWord4/CkEditorWord4';
import { QuestionDetailImportRequest, QuestionDetailRequest } from 'model/request';
import { useEffect, useRef, useState } from 'react';
import { CK_EDITOR_BASE_CONFIG } from '../../../common/constant';
import { QuestionDetail } from 'model/response';

type Props = {
  questionDetails: QuestionDetailImportRequest[] | QuestionDetail[] | QuestionDetailRequest[] | null | undefined;
  commitChange: (dataChange: any, rightAnswer: string | number | undefined | null, questionType: QuestionType) => void;
  rightAnswer: string | number | undefined | null;
};

const config = {
  ...CK_EDITOR_BASE_CONFIG,
  height: 100,
  extraPlugins: 'niw_btn,ckeditor_wiris',
  allowedContent: true,
  font_defaultLabel: 'Arial',
  fontSize_defaultLabel: 16,
  contentsCss: ["body {font-size: 18px; font-family: 'Arial';word-wrap:break-word;}"],
  actionFocus: false,
  startupFocus: false,
};

export default function EditOneChoiceQuestion({ questionDetails, commitChange, rightAnswer }: Props) {
  const [questionDetailsEdit, setQuestionDetailsEdit] = useState<
    QuestionDetailImportRequest[] | QuestionDetail[] | QuestionDetailRequest[] | null | undefined
  >(questionDetails);
  const questionDetailsEditRef = useRef<
    QuestionDetailImportRequest[] | QuestionDetail[] | QuestionDetailRequest[] | null | undefined
  >();
  const [rightAnswerEdit, setRightAnswerEdit] = useState<string | number | undefined | null>(Number(rightAnswer));

  const addAnswer = function (e: any) {
    const newQuestionDetail = {
      id: uuidv4(),
      description: '',
      questionDetailIndex: questionDetailsEdit?.length as number,
      code: '',
      image: '',
    };

    const questionDetailsEditTemp = questionDetailsEditRef.current ? [...questionDetailsEditRef.current] : [];
    questionDetailsEditTemp.push(newQuestionDetail);

    commitChange(questionDetailsEditTemp, null, QuestionType.ONE_CHOICE_QUESTION);
  };

  const deleteAnswer = function (
    e: any,
    questionDetail: QuestionDetailImportRequest | QuestionDetail | QuestionDetailRequest,
  ) {
    let questionDetailsEditTemp = questionDetailsEditRef.current ? [...questionDetailsEditRef.current] : [];

    questionDetailsEditTemp = questionDetailsEditTemp.filter((item) => item.id !== questionDetail.id);

    commitChange(questionDetailsEditTemp, null, QuestionType.ONE_CHOICE_QUESTION);
  };

  const handleChangeRightAnswer = function (e: any) {
    commitChange(null, Number(e.target.value), QuestionType.ONE_CHOICE_QUESTION);
  };

  const onChangeAnswerDescription = (content: string, editor: any) => {
    const questionDetailsEditTemp = questionDetailsEditRef.current ? [...questionDetailsEditRef.current] : [];
    for (let i = 0; i < questionDetailsEditTemp.length; i++) {
      if (questionDetailsEditTemp[i].id === editor.edit_data_id) {
        questionDetailsEditTemp[i] = { ...questionDetailsEditTemp[i], description: content };
      }
    }

    commitChange(questionDetailsEditTemp, null, QuestionType.ONE_CHOICE_QUESTION);
  };

  useEffect(() => {
    setQuestionDetailsEdit(questionDetails);
    setRightAnswerEdit(rightAnswer);
    questionDetailsEditRef.current = questionDetails;
  }, [questionDetails, rightAnswer]);

  return (
    <>
      <div className="text-[18px] text-left">
        <i>(Thiết lập 1 đáp án đúng trong 4 câu trả lời)</i>
      </div>
      {questionDetailsEdit?.map((questionDetail) => {
        return (
          <div className="w-full flex mt-2 gap-2 items-center" key={questionDetail.questionDetailIndex}>
            <Input
              type="radio"
              className="w-[20px] h-[20px]"
              name="rightChoice"
              value={questionDetail.questionDetailIndex}
              checked={questionDetail.questionDetailIndex === Number(rightAnswerEdit)}
              onChange={(e) => {
                handleChangeRightAnswer(e);
              }}
            />
            <div className="flex-1">
              <CkEditorWord4
                config={config}
                value={questionDetail?.description ?? ''}
                keyId={questionDetail.id}
                onChangeEditor={(content, editor) => {
                  onChangeAnswerDescription(content, editor);
                }}
              />
            </div>
            <button
              className="w-fit h-fit cursor-pointer rounded-[20px] px-2 py-1 hover:bg-red-400"
              onClick={(e) => {
                deleteAnswer(e, questionDetail);
              }}
            >
              <CloseOutlined />
            </button>
          </div>
        );
      })}
      <div className="flex justify-start mt-4">
        <button
          className="py-1 bg-[#e6f8ff] hover:bg-[#d8f0fa] flex items-center rounded px-2"
          onClick={(e) => {
            addAnswer(e);
          }}
        >
          <PlusOutlined className="text-[15px]" />
          <span className="pl-2">Thêm câu trả lời</span>
        </button>
      </div>
    </>
  );
}
